<hb-modal-dialog
  [heading]="title"
  [okDisabled]="!isValid()"
  (okClicked)="okClick()">
  <div content>
    <div class="form-group row">
      <div class="col col-md-4">
        <h5 class="thin dk-gray text-right no-wrap" style="margin-top: .5rem;">{{'ConsequenceRiskMatrixSelectionDialog.RiskMatrix' | i18next}}</h5>
      </div>
      <div class="col col-md-4">
        <select class="form-control form-control-sm custom-select" [(ngModel)]="selectedRiskMatrixId"
          (ngModelChange)="onSelectedMatrixChanged()">
          <option *ngFor="let riskMatrix of riskMatrices" [value]="riskMatrix.riskMatrixId">{{riskMatrix.name}}</option>
        </select>
      </div>
    </div>
    <div class="form-group row">
      <div class="col col-md-12 d-flex justify-content-center">
        <hb-risk-matrix-grid *ngIf="selectedRiskMatrix" [alwaysDisplayCellLabels]="true"
          [riskMatrix]="selectedRiskMatrix" [isEditable]="false" [drawCircle]="true"
          [matrixCalibration]="matrixCalibration" (onCellClicked)="onCellClicked($event)"></hb-risk-matrix-grid>
      </div>
    </div>
    <div *ngIf="selectedRiskMatrixCell">
      <div class="form-group row" *ngIf="selectedRiskMatrixId">
        <div class="col col-md-12 d-flex justify-content-center">
          {{'ConsequenceRiskMatrixSelectionDialog.SelectedRiskRanking' | i18next}} {{ selectedRiskRanking }}
        </div>
      </div>
      <div class="form-group row" *ngIf="selectedRiskMatrixId && selectedRiskMatrixCellCalibrationProbability">
        <div *ngIf="selectedRiskMatrixCellCalibrationProbability.lowerLimit" class="col col-md-6" style="text-align: right">
          {{'ConsequenceRiskMatrixSelectionDialog.LowerProbability' | i18next}} {{ selectedRiskMatrixCellCalibrationProbability.lowerLimit }}
        </div>
        <div *ngIf="selectedRiskMatrixCellCalibrationProbability.upperLimit" class="col col-md-6">
          {{'ConsequenceRiskMatrixSelectionDialog.UpperProbability' | i18next}} {{ selectedRiskMatrixCellCalibrationProbability.upperLimit }}
        </div>
      </div>
      <div class="form-group row" *ngIf="selectedRiskMatrixId && selectedRiskMatrixCellCalibrationConsequence">
        <div *ngIf="selectedRiskMatrixCellCalibrationConsequence.lowerLimit" class="col col-md-6" style="text-align: right">
          {{'ConsequenceRiskMatrixSelectionDialog.LowerConsequence' | i18next}} {{ selectedRiskMatrixCellCalibrationConsequence.lowerLimit }}
        </div>
        <div *ngIf="selectedRiskMatrixCellCalibrationConsequence.upperLimit" class="col col-md-6">
          {{'ConsequenceRiskMatrixSelectionDialog.UpperConsequence' | i18next}} {{ selectedRiskMatrixCellCalibrationConsequence.upperLimit }}
        </div>
      </div>
    </div>
    <div *ngIf="!selectedRiskMatrixCell" class="form-group row">
      <div class="col col-md-12 d-flex justify-content-center">
        {{'ConsequenceRiskMatrixSelectionDialog.PleaseSelectCell' | i18next}}
      </div>
    </div>
  </div>
</hb-modal-dialog>
